<template>
  <div class="modal fade" tabindex="-1" role="dialog" id="create-time-based-ad-location-modal">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <form @submit.prevent="submit">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">
                &times;
              </span>
            </button>

            <h4 class="modal-title">
              Create Location
            </h4>
          </div>

          <div class="modal-body">
            <TextFormGroup
                v-model="data.name"
                name="name"
                label="Name"
                :error="getError('name')"
            />
          </div>

          <div class="modal-footer">
            <button type="button" class="btn btn-default" data-dismiss="modal">
              Close
            </button>

            <button type="submit" class="btn btn-black">
              <i class="fa fa-save"></i> Save
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import http from '@/http'
import notify from '@/notify'
import Errors from '@/mixins/Errors'
import TextFormGroup from '@/vendor/forms/FormGroups/Block/Text'

export default {
  components: {TextFormGroup},

  mixins: [Errors],

  props: {
    timeBasedChannel: {
      required: true
    }
  },

  data() {
    return {
      data: {}
    }
  },

  mounted() {
    this.listenForClose()
  },

  methods: {
    listenForClose() {
      $(this.$el).on('hidden.bs.modal', this.reset)
    },

    submit() {
      http.post('/api/v2/time-based-ad-locations', {
        ...this.data,
        time_based_channel_id: this.timeBasedChannel.id,
      })
          .then(response => {
            notify.success('The location was saved')

            this.$emit('created', response.data.data)

            $(this.$el).modal('hide')
          })
          .catch(error => {
            if (error.response.status === 400) {
              return notify.error(error.response.data.message)
            }

            throw error
          })
          .catch(this.catchValidationErrors)
    },

    reset() {
      this.errors = {}

      this.data = {}
    }
  }
}
</script>
